<script>
  export default {
    props: {
      investorContact: {
        type: Object,
        default: () => {
        }
      }
    },
    data() {
      return {}
    },
    methods: {
      isShow(item) {
        const value = Object.values(item)
        return value.some((item) => {
          return item !== null
        })
      }
    }
  }
</script>
<template>
  <section :class="$style.sectionInvestorContact" class="section ">
    <div class="container">
      <BaseSectionTitle title="投資人關係處理窗口" class="text-center"/>
      <div class="row sectionInvestorContact__list">
        <div v-if="isShow(investorContact['transfer-agency'])" class="col-md-6 sectionInvestorContact__item">
          <div class="sectionInvestorContact__box">
            <h3 class="title">辦理股票過戶機構</h3>
            <div class="bottom">
              <p  v-if="investorContact['transfer-agency'].title"
                class="bottom__title">
                {{ investorContact['transfer-agency'].title }}
              </p>
              <ul class="list-unstyled bottom__list mb-0">
                <li 
                  v-if="investorContact['transfer-agency'].address" 
                  class="bottom__item"
                >
                  地址：
                  <a
                    :href="`https://www.google.com.tw/maps/search/${investorContact['transfer-agency'].address}`"
                    target="_blank"
                    class="link"
                  >
                    {{ investorContact['transfer-agency'].address }}

                  </a>
                  <img src="@assets/images/about/mapIcon.svg" alt="" style="padding-bottom: 7px;">
                </li>
                <li 
                  v-if="investorContact['transfer-agency'].phone" 
                  class="bottom__item"
                >
                  電話：
                  <a
                    :href="`tel:${investorContact['transfer-agency'].phone}`"
                    class="link"
                  >
                    {{ investorContact['transfer-agency'].phone }}
                  </a>
                </li>
                <li  
                  v-if="investorContact['transfer-agency'].site" 
                  class="bottom__item"
                >
                  網站：
                  <a
                    :href="`${investorContact['transfer-agency'].site}`"
                    class="link web"
                  >
                    {{investorContact['transfer-agency'].site}}
                  </a>
                </li>
              </ul>
            </div>
          </div>

        </div>
        <div 
          v-if="isShow(investorContact['contact-person'])" 
          class="col-md-6 sectionInvestorContact__item"
        >
          <div class="sectionInvestorContact__box">
            <h3 class="title">投資人關係處理窗口</h3>
            <div class="bottom">
              <p 
                v-if="investorContact['contact-person'].name"
                class="bottom__title"
              >
                {{ investorContact['contact-person'].name }}
              </p>
              <ul class="list-unstyled bottom__list">
                <li 
                  v-if="investorContact['contact-person'].phone" 
                  class="bottom__item"
                >
                  電話：
                  <a
                    :href="`tel:${investorContact['contact-person'].phone}`"
                    class="link"
                  >
                    {{ investorContact['contact-person'].phone }}
                  </a>
                </li>
                <li 
                  v-if="investorContact['contact-person'].email" 
                  class="bottom__item">
                  Email：
                  <a
                    :href="`mailTo:${investorContact['contact-person'].email}`"
                    class="link"
                  >
                    {{ investorContact['contact-person'].email }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<style lang="scss" module>
  .sectionInvestorContact {
    :global {
      .sectionInvestorContact {
        &__list {

        }

        &__item {

        }

        &__box {
          min-height: 371px;
          padding: 4rem 50px;
          border: 1px solid $color-gray-2;
          border-radius: 2px;

          @include max-md {
            min-height: auto;
            padding: 2rem 1rem;
            margin-bottom: 1rem;
          }

          .title {
            padding-bottom: 2rem;
            border-bottom: 1px solid rgba(177, 186, 202, 1);

            @include max-md {
              font-size: 1.25rem;
            }
          }

          .bottom {
            margin-top: 30px;

            &__title {
              font-size: 1.25rem;
              @include max-md {
                font-size: 1rem;
              }
            }

            &__list {
              margin-top: 24px;
            }

            &__item {
              line-height: 1.75;

              .link {
                margin-left: -5px;
                color: $color-gray-7;
                transition: .3s;
                @include max-md {
                  font-size: 0.875rem;
                }
                &.web {
                  color: $color-primary;
                  transition: .3s;
                }

                &:hover {
                  color: $color-primary-hover;
                  text-decoration: none;
                }
              }
            }
          }
        }
      }
    }
  }
</style>
